/**
 * This utils is used in drag and drop. It enables to provide more data for drag and drop related events (i.e. dragover, drop) that native DataTransfer available from event.
 * https://developer.mozilla.org/en-US/docs/Web/API/DataTransfer
 */

let data: unknown;

export function dataTransfer<T>(): T;
export function dataTransfer<T>(value: T): void;
// It's a singleton, assuming that there's only one drag interaction at a time
export function dataTransfer<T>(value?: T) {
  if (arguments.length) {
    if (value != null) {
      data = value;
    }
  } else {
    return data as T;
  }
}

// Util to ensure a correct listener setup
export function setupDataTransfer(el: HTMLElement, getDataFromEvent: (event: DragEvent) => unknown) {
  el.addEventListener('dragstart', (event) => {
    dataTransfer(getDataFromEvent(event));
  });

  if (el.tagName === 'D-SORTABLE-LIST') {
    // in case of sortable list, 'ondragend' is triggered on dragged element, not the list itself (see sortablejs#_triggerDragStart)
    Array.from(el.children).forEach((item) => {
      item.addEventListener('dragend', () => {
        clearDataTransfer();
      });
    });
  } else {
    el.addEventListener('dragend', () => {
      clearDataTransfer();
    });
  }

  el.addEventListener('drop', () => {
    clearDataTransfer();
  });
}

function clearDataTransfer() {
  dataTransfer(undefined);
}
